module.exports = __webpack_public_path__ + "media/images/m-soudanshitu-0ab9b276.png";